export default __webpack_public_path__ + "static/media/logo-sm.6cc4db13.png";